module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative"
  }, [_c('div', {
    staticClass: "imgMain",
    style: (_vm.styleObject)
  }, [_c('img', {
    attrs: {
      "src": _vm.img,
      "alt": "",
      "height": "100%"
    },
    on: {
      "load": _vm.imgLoad
    }
  }), _vm._v(" "), (!_vm.imgLoaded) ? _c('div', [_vm._v(_vm._s(_vm.loadingText))]) : _vm._e()]), _vm._v(" "), _vm._t("another"), _vm._v(" "), _c('div', {
    style: (_vm.slotObject)
  }, [_vm._t("default")], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07153e9a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue-components/img/img.vue
// module id = 273
// module chunks = 1